import { formatFieldValue, getFieldValueLabel } from './Field';
import { toFormattedDate } from 'components/DateTime';
export function getDealItemName(dealItem, language, fields, dealItemFields, showDate = false) {
    var _a, _b, _c;
    let name = dealItem.item.title;
    let variantNameConfig = 'NONE';
    const fieldValues = [];
    if (dealItemFields === null || dealItemFields === void 0 ? void 0 : dealItemFields.length) {
        dealItemFields.forEach((field) => {
            var _a;
            const v = (_a = dealItem.fieldValues) === null || _a === void 0 ? void 0 : _a.find((value) => value.field.id === field.id);
            if (v) {
                fieldValues.push(formatFieldValue(v.value, field.type));
            }
        });
    }
    const configuration = fields === null || fields === void 0 ? void 0 : fields.find((conf) => conf.fieldKey === 'VARIANT_NAME');
    if (configuration) {
        variantNameConfig = JSON.parse(configuration.value).value;
    }
    if (configuration) {
        switch (variantNameConfig) {
            case 'SKU':
                name += ` - ${(_a = dealItem.variant) === null || _a === void 0 ? void 0 : _a.sku}`;
                break;
            case 'TITLE':
                name += ((_b = dealItem.variant) === null || _b === void 0 ? void 0 : _b.title) ? ` - ${(_c = dealItem.variant) === null || _c === void 0 ? void 0 : _c.title}` : '';
                break;
            case 'FIELD_VALUE':
                if (dealItem.variant) {
                    let variantValue = '';
                    dealItem.variant.values.forEach((value) => {
                        variantValue += `${getFieldValueLabel(value.value, value.field, language)} `;
                    });
                    name += ` - ${variantValue}`;
                }
                break;
            case 'NONE':
            default:
                break;
        }
    }
    if (showDate && dealItem.date) {
        name += ` - ${toFormattedDate(dealItem.date, { y: 'numeric', m: 'numeric', d: 'numeric' })}`;
    }
    return (name + (fieldValues.length ? ' (' + fieldValues.join(' - ') + ')' : ''));
}
export function getRelations(item, variant, option, dealOptions, skiFiltering = false) {
    var _a, _b, _c, _d, _e, _f, _g;
    // Get relations for the option
    const optionRelations = (_a = option === null || option === void 0 ? void 0 : option.relations) !== null && _a !== void 0 ? _a : [];
    // Get relations for the deal item
    const itemRelations = (_d = (_c = (_b = item === null || item === void 0 ? void 0 : item.options) === null || _b === void 0 ? void 0 : _b.find((entry) => entry.item.id === (option === null || option === void 0 ? void 0 : option.id))) === null || _c === void 0 ? void 0 : _c.relations) !== null && _d !== void 0 ? _d : [];
    // Get the relations for the variant
    const variantRelations = (_g = (_f = (_e = variant === null || variant === void 0 ? void 0 : variant.options) === null || _e === void 0 ? void 0 : _e.find((entry) => entry.item.id === (option === null || option === void 0 ? void 0 : option.id))) === null || _f === void 0 ? void 0 : _f.relations) !== null && _g !== void 0 ? _g : [];
    const relations = [...optionRelations, ...itemRelations, ...variantRelations];
    if (skiFiltering) {
        return relations;
    }
    // Filter relations to only include those that are relevant to the current item
    const filteredRelations = relations.filter((relation) => {
        if (relation.type == 'CONDITIONAL') {
            const option = dealOptions.find((entry) => entry.item.id == relation.relatedSaleItem.id);
            if (option == null) {
                return true;
            }
            return false;
        }
        if (relation.type == 'INCOMPATIBLE') {
            const option = dealOptions.find((entry) => entry.item.id == relation.relatedSaleItem.id);
            if (option == null) {
                return false;
            }
            return true;
        }
    });
    return filteredRelations;
}
